import { IQuestionModel } from '@care-portals/api-interfaces';

const questionsModels: IQuestionModel[] = [
  {
    // Education Slide
    field: 'intakeEducationSlide',
    type: 'info',
    educationalSlide: `Welcome to virtual therapy at Momwell! We understand that you are busy, and forms can be a pain– but they are necessary. Please take 15-20 mins to fill out our online intake form before your first visit. 
    
    You only have to do this once, and all of your information is completely confidential. The forms will automatically save as you go so feel free to complete them all in one sitting or come back to finish them at a later date.`,
    label: '',
    answer: {}
  },

  {
    label: 'Profile Information',
    subLabel: '',
    field: 'intakeFirst',
    type: 'info',
    answer: {
      type: 'list',
      items: [
        {
          label: 'First Name *',
          type: 'text',
          name: 'intakeFirstName',
          rows: 1
        },
        {
          label: 'Last Name *',
          type: 'text',
          name: 'intakeLastName',
          rows: 1
        },
        {
          label: 'Preferred Name (if different)',
          type: 'text',
          name: 'intakePreferredName',
          rows: 1,
          optional: true
        },
        {
          label: 'Prefix/Title',
          type: 'text',
          name: 'intakePrefixTitle',
          rows: 1,
          optional: true
        },
        {
          label: 'Preferred Pronouns',
          type: 'text',
          name: 'intakePreferredPronoun',
          rows: 1,
          optional: true
        },
        {
          label: 'Email *',
          type: 'text',
          name: 'intakeEmail',
          rows: 1
        },
        {
          label: 'Mobile Phone *',
          type: 'text',
          name: 'intakeMobilePhone',
          rows: 1
        },
        {
          label: 'Home Phone *',
          type: 'text',
          name: 'intakeHomePhone',
          rows: 1
        },
        {
          label: 'Country *',
          type: 'text',
          name: 'intakeCountry',
          rows: 1
        },
        {
          label: 'Street Address *',
          type: 'text',
          name: 'intakeStreetAddress',
          rows: 1
        },
        {
          label: 'City *',
          type: 'text',
          name: 'intakeCity',
          rows: 1
        },
        {
          label: 'Province/State *',
          type: 'text',
          name: 'intakeProvinceState',
          rows: 1
        },
        {
          label: 'Postal Code/Zip Code *',
          type: 'text',
          name: 'intakePostalZipCode',
          rows: 1
        },
        {
          label: 'Date of Birth *',
          type: 'text',
          name: 'intakeDateOfBirth',
          rows: 1,
          placeholder: 'DD/MM/YYYY'
        }
      ]
    }
  },

  // {
  //   // Emergency Slide
  //   field: 'intakeEmergencySlide',
  //   type: 'info',
  //   educationalSlide: `As part of our commitment to providing you with the best possible care, the following section collects essential emergency information.  We understand that discussing emergencies may seem distressing, but please rest assured that the information collected is only for emergency purposes to ensure that by providing us with the necessary details, we can swiftly connect you with appropriate local  resources and professional assistance if needed.`,
  //   label: '',
  //   answer: {}
  // },

  {
    label:
      'As part of our commitment to providing you with the best possible care, the following section collects essential emergency information.  We understand that discussing emergencies may seem distressing, but please rest assured that the information collected is only for emergency purposes to ensure that by providing us with the necessary details, we can swiftly connect you with appropriate local  resources and professional assistance if needed.',
    subLabel:
      'In the event of an emergency please provide the following necessary information:',
    field: 'intakeEmergencyEvent',
    type: 'info',
    answer: {
      type: 'list',
      items: [
        {
          label: 'Emergency Contact *',
          type: 'text',
          name: 'intakeEmergencyContact',
          rows: 1
        },
        {
          label: 'Emergency Contact Phone *',
          type: 'text',
          name: 'intakeEmergencyContactPhone',
          rows: 1
        },
        {
          label: 'Emergency Contact Relationship *',
          type: 'text',
          name: 'intakeEmergencyContactRelationShip',
          rows: 1
        },
        {
          label: 'Name of closest hospital/emergency room *',
          type: 'text',
          name: 'intakeClosestHospital',
          rows: 1
        },
        {
          label: 'Hospital address *',
          type: 'text',
          name: 'intakeHospitalAddress',
          rows: 1
        },
        {
          label: 'Hospital telephone number *',
          type: 'text',
          name: 'intakeHospitalNumber',
          rows: 1
        },
        {
          label: 'Name of the closest police department *',
          type: 'text',
          name: 'intakeNearestPolice',
          rows: 1
        },
        {
          label: 'Police department address *',
          type: 'text',
          name: 'intakePoliceAddress',
          rows: 1
        },
        {
          label: 'Police department phone number *',
          type: 'text',
          name: 'intakePolicePhoneNumber',
          rows: 1
        },
        {
          label: 'Primary Doctor/Physician Name (if known)',
          type: 'text',
          name: 'intakePrimaryDoctorName',
          rows: 1,
          optional: true
        },
        {
          label: 'Primary Doctor/Physician Phone (if known)',
          type: 'text',
          name: 'intakePrimaryDoctorPhone',
          rows: 1,
          optional: true
        },
        {
          label: 'Primary Doctor/Physician Email (if known)',
          type: 'text',
          name: 'intakePrimaryDoctorEmail',
          rows: 1,
          optional: true
        },
        {
          label: 'Occupation',
          type: 'text',
          name: 'intakeOccupation',
          rows: 1,
          optional: true
        },
        {
          label: 'Employer',
          type: 'text',
          name: 'intakeEmployer',
          rows: 1,
          optional: true
        },
        {
          label: 'How did you hear about us? *',
          type: 'text',
          name: 'intakeHowHearAboutUs',
          rows: 1
        },
        {
          label: 'What brought you to Momwell? *',
          type: 'text',
          name: 'intakeBroughtToMomwell',
          rows: 1
        },
        {
          label: 'Who were you referred to?',
          type: 'text',
          name: 'intakeReferredTo',
          rows: 1,
          optional: true
        },
      ]
    }
  },

  {
    label: 'Reason for seeking therapy',
    subLabel: '',
    field: 'intakeTherapyPart',
    type: 'info',
    answer: {
      type: 'list',
      items: [
        {
          label:
            'What brings you to therapy at this time? Please be as detailed as possible. *',
          type: 'text',
          name: 'intakeWhatBringsTherapy',
          rows: 1
        },
        {
          label:
            'Please check any of the following symptoms you have experienced in the past 6 months. *',
          type: 'multi_select',
          field: 'experiencedSymptoms',
          level: 'child',
          options: [
            { key: 'IncreasedAppetite', value: 'Increased appetite' },
            { key: 'DecreasedAppetite', value: 'Decreased appetite' },
            { key: 'TroubleConcentrating', value: 'Trouble concentrating' },
            { key: 'DifficultySleeping', value: 'Difficulty sleeping' },
            { key: 'ExcessiveSleep', value: 'Excessive sleep' },
            { key: 'LowMotivation', value: 'Low motivation' },
            { key: 'IsolationFromOthers', value: 'Isolation from others' },
            { key: 'FatigueLowEnergy', value: 'Fatigue/low energy' },
            { key: 'LowSelfEsteem', value: 'Low self-esteem' },
            { key: 'DepressedMood', value: 'Depressed mood' },
            { key: 'TearfulOrCryingSpells', value: 'Tearful or crying spells' },
            { key: 'Anxiety', value: 'Anxiety' },
            { key: 'Fear', value: 'Fear' },
            { key: 'Hopelessness', value: 'Hopelessness' },
            { key: 'Panic', value: 'Panic' },
            { key: 'Irritability', value: 'Irritability' },
            { key: 'MomRage', value: 'Mom Rage' },
            { key: 'RacingThoughts', value: 'Racing thoughts' },
            { key: 'BadDreamsNightmares', value: 'Bad dreams/Nightmares' },
            {
              key: 'LossOfInterestInActivities',
              value: 'Loss of interest in activities'
            },
            { key: 'IntrusiveThoughts', value: 'Intrusive thoughts' }
          ]
        },
        {
          label:
            'How long have the symptoms been occurring and when did they start? *',
          type: 'text',
          name: 'intakeSymptomsOccurring',
          rows: 1
        },
        {
          label: 'What are your current coping strategies? *',
          type: 'text',
          name: 'intakeCurrentCopingStrategies',
          rows: 1
        },
        {
          label: 'How have you coped with hard situations in the past? *',
          type: 'text',
          name: 'intakeHowCopedWithHardSituations',
          rows: 1
        },
        {
          label:
            'Did you experience PMS symptoms? Would you say they were mild, moderate or severe?',
          type: 'text',
          name: 'intakePMSSymptoms',
          rows: 1,
          optional: true
        },
        {
          label: 'Have you seen a mental health professional before? *',
          type: 'single_select',
          field: 'seenMentalHealth',
          level: 'child',
          options: [
            { key: 'Mental Health professional yes', value: 'Yes' },
            { key: 'Mental Health professional no', value: 'No' }
          ]
        },
        {
          label:
            'What are your goals for therapy and what are you hoping to get out of speaking to a therapist? *',
          type: 'text',
          name: 'intakeTherapyGoals',
          rows: 1
        },
        {
          label: 'Do you have a medical or mental health diagnosis?',
          type: 'text',
          name: 'intakeHaveMedicalDiagnosis',
          rows: 1,
          optional: true
        },
        {
          label:
            "Medications and Supplements: List all medications you're currently taking.",
          type: 'text',
          name: 'intakeMedicationsList',
          rows: 1,
          optional: true
        },
        {
          label: 'Who is prescribing and overseeing your medications?',
          type: 'text',
          name: 'intakePrescribing',
          rows: 1,
          optional: true
        },
        {
          label: 'Are there any stressors in your home? *',
          type: 'multi_select',
          field: 'anyStressors',
          level: 'child',
          options: [
            { key: 'Separation Divorce', value: 'Separation/Divorce' },
            { key: 'Ageing Parents', value: 'Ageing Parents' },
            { key: 'Legal Problems', value: 'Legal Problems' },
            { key: 'Alcohol Drug Abuse', value: 'Alcohol/Drug Abuse' },
            { key: 'Unemployment', value: 'Unemployment' },
            { key: 'Job Problems', value: 'Job Problems' },
            { key: 'Childcare', value: 'Childcare' },
            { key: 'Death', value: 'Death' },
            { key: 'Accidents', value: 'Accidents' },
            { key: 'Long Work Hours', value: 'Long Work Hours' },
            { key: 'Lack of Support', value: 'Lack of Support' },
            { key: 'NA', value: 'N/A' }
          ]
        }
      ]
    }
  },
  {
    label: 'Reason for seeking therapy',
    subLabel: '',
    field: 'intakeTherapyPartnerPart',
    type: 'info',
    answer: {
      type: 'list',
      items: [
        {
          label:
            'What brings you to therapy at this time? Please be as detailed as possible. *',
          type: 'text',
          name: 'intakeWhatBringsTherapy',
          rows: 1
        },
        {
          label:
            'Please check any of the following symptoms you have experienced in the past 6 months. *',
          type: 'multi_select',
          field: 'experiencedSymptoms',
          level: 'child',
          options: [
            { key: 'IncreasedAppetite', value: 'Increased appetite' },
            { key: 'DecreasedAppetite', value: 'Decreased appetite' },
            { key: 'TroubleConcentrating', value: 'Trouble concentrating' },
            { key: 'DifficultySleeping', value: 'Difficulty sleeping' },
            { key: 'ExcessiveSleep', value: 'Excessive sleep' },
            { key: 'LowMotivation', value: 'Low motivation' },
            { key: 'IsolationFromOthers', value: 'Isolation from others' },
            { key: 'FatigueLowEnergy', value: 'Fatigue/low energy' },
            { key: 'LowSelfEsteem', value: 'Low self-esteem' },
            { key: 'DepressedMood', value: 'Depressed mood' },
            { key: 'TearfulOrCryingSpells', value: 'Tearful or crying spells' },
            { key: 'Anxiety', value: 'Anxiety' },
            { key: 'Fear', value: 'Fear' },
            { key: 'Hopelessness', value: 'Hopelessness' },
            { key: 'Panic', value: 'Panic' },
            { key: 'Irritability', value: 'Irritability' },
            { key: 'MomRage', value: 'Mom Rage' },
            { key: 'RacingThoughts', value: 'Racing thoughts' },
            { key: 'BadDreamsNightmares', value: 'Bad dreams/Nightmares' },
            {
              key: 'LossOfInterestInActivities',
              value: 'Loss of interest in activities'
            },
            { key: 'IntrusiveThoughts', value: 'Intrusive thoughts' }
          ]
        },
        {
          label:
            'How long have the symptoms been occurring and when did they start? *',
          type: 'text',
          name: 'intakeSymptomsOccurring',
          rows: 1
        },
        {
          label: 'What are your current coping strategies? *',
          type: 'text',
          name: 'intakeCurrentCopingStrategies',
          rows: 1
        },
        {
          label: 'How have you coped with hard situations in the past? *',
          type: 'text',
          name: 'intakeHowCopedWithHardSituations',
          rows: 1
        },
        {
          label: 'Have you seen a mental health professional before? *',
          type: 'single_select',
          field: 'seenMentalHealth',
          level: 'child',
          options: [
            { key: 'Mental Health professional yes', value: 'Yes' },
            { key: 'Mental Health professional no', value: 'No' }
          ]
        },
        {
          label:
            'What are your goals for therapy and what are you hoping to get out of speaking to a therapist? *',
          type: 'text',
          name: 'intakeTherapyGoals',
          rows: 1
        },
        {
          label: 'Do you have a medical or mental health diagnosis?',
          type: 'text',
          name: 'intakeHaveMedicalDiagnosis',
          rows: 1,
          optional: true
        },
        {
          label:
            "Medications and Supplements: List all medications you're currently taking.",
          type: 'text',
          name: 'intakeMedicationsList',
          rows: 1,
          optional: true
        },
        {
          label: 'Who is prescribing and overseeing your medications?',
          type: 'text',
          name: 'intakePrescribing',
          rows: 1,
          optional: true
        },
        {
          label: 'Are there any stressors in your home? *',
          type: 'multi_select',
          field: 'anyStressors',
          level: 'child',
          options: [
            { key: 'Separation Divorce', value: 'Separation/Divorce' },
            { key: 'Ageing Parents', value: 'Ageing Parents' },
            { key: 'Legal Problems', value: 'Legal Problems' },
            { key: 'Alcohol Drug Abuse', value: 'Alcohol/Drug Abuse' },
            { key: 'Unemployment', value: 'Unemployment' },
            { key: 'Job Problems', value: 'Job Problems' },
            { key: 'Childcare', value: 'Childcare' },
            { key: 'Death', value: 'Death' },
            { key: 'Accidents', value: 'Accidents' },
            { key: 'Long Work Hours', value: 'Long Work Hours' },
            { key: 'Lack of Support', value: 'Lack of Support' },
            { key: 'NA', value: 'N/A' }
          ]
        }
      ]
    }
  },

  {
    label: 'Personal Information',
    subLabel: '',
    field: 'intakePersonalPart',
    type: 'info',
    answer: {
      type: 'list',
      items: [
        {
          label: 'Do you believe in God? *',
          type: 'single_select',
          level: 'child',
          field: 'believeInGod',
          options: [
            { key: 'God believer yes', value: 'Yes' },
            { key: 'God believer no', value: 'No' }
          ]
        },
        {
          label:
            'Were you raised attending church? Temple? Involved in any kind of faith community? *',
          type: 'single_select',
          level: 'child',
          field: 'faithCommunity',
          options: [
            { key: 'attending church Temple yes', value: 'Yes' },
            { key: 'attending church Temple no', value: 'No' }
          ]
        },
        {
          label: 'Highest level of education completed *',
          type: 'single_select',
          field: 'educationalLevel',
          level: 'child',
          options: [
            { key: 'High School Diploma', value: 'High School Diploma' },
            {
              key: 'College Associates Degree or Diploma',
              value: 'College Associates Degree or Diploma'
            },
            {
              key: "University or College Bachelor's Degree",
              value: "University or College Bachelor's Degree"
            },
            { key: 'Masters Degree', value: 'Master’s Degree' },
            { key: 'Ph D', value: 'Ph.D' }
          ]
        },
        {
          label: 'Do you drink alcohol? *',
          type: 'single_select',
          field: 'drinkAlcohol',
          level: 'child',
          options: [
            { key: 'alcohol yes', value: 'Yes' },
            { key: 'alcohol no', value: 'No' }
          ]
        },
        {
          label: 'Do you use recreational drugs? *',
          type: 'single_select',
          level: 'child',
          field: 'useRecreationalDrugs',
          options: [
            { key: 'drugs yes', value: 'Yes' },
            { key: 'drugs no', value: 'No' }
          ]
        },
        {
          label: 'Do you smoke? *',
          type: 'single_select',
          field: 'smoke',
          level: 'child',
          options: [
            { key: 'smoke yes', value: 'Yes' },
            { key: 'smoke no', value: 'No' }
          ]
        },
        {
          label: 'Do you have suicidal thoughts? *',
          type: 'single_select',
          field: 'suicidalThoughts',
          level: 'child',
          options: [
            { key: 'suicidal thoughts yes', value: 'Yes' },
            { key: 'suicidal thoughts no', value: 'No' }
          ]
        },
        {
          label: 'Have you ever attempted suicide? *',
          type: 'single_select',
          level: 'child',
          field: 'attemptedSuicide',
          options: [
            { key: 'attempted suicide yes', value: 'Yes' },
            { key: 'attempted suicide no', value: 'No' }
          ]
        },
        {
          label: 'Do you have thoughts or urges to harm others? *',
          type: 'single_select',
          level: 'child',
          field: 'harmOthers',
          options: [
            { key: 'urges to harm others yes', value: 'Yes' },
            { key: 'urges to harm others no', value: 'No' }
          ]
        },
        {
          label: 'Have you ever been hospitalized for a psychiatric issue? *',
          type: 'single_select',
          field: 'psychiatricIssue',
          level: 'child',
          options: [
            { key: 'hospitalized psychiatric issue yes', value: 'Yes' },
            { key: 'hospitalized psychiatric issue no', value: 'No' }
          ]
        },
        {
          label: 'Have you ever experienced physical abuse? *',
          type: 'single_select',
          field: 'physicalAbuse',
          level: 'child',
          options: [
            { key: 'physical abuse yes', value: 'Yes' },
            { key: 'physical abuse no', value: 'No' }
          ]
        },
        {
          label: 'Have you ever experienced sexual abuse? *',
          type: 'single_select',
          level: 'child',
          field: 'sexualAbuse',
          options: [
            { key: 'sexual abuse yes', value: 'Yes' },
            { key: 'sexual abuse no', value: 'No' }
          ]
        },
        {
          label: 'Have you ever experienced emotional or verbal abuse? *',
          type: 'single_select',
          level: 'child',
          field: 'verbalAbuse',
          options: [
            { key: 'emotional verbal abuse yes', value: 'Yes' },
            { key: 'emotional verbal abuse no', value: 'No' }
          ]
        },
        {
          label:
            'Are you coping with any developmental delays, physical limitations, chronic illness or pain? *',
          type: 'single_select',
          level: 'child',
          field: 'copingWithEtc',
          options: [
            { key: 'coping with etc yes', value: 'Yes' },
            { key: 'coping with etc no', value: 'No' }
          ]
        },
        {
          label:
            'Do you have a history of trauma other than what has been listed here?',
          type: 'text',
          name: 'intakeHistoryOfTrauma',
          rows: 1,
          optional: true
        },
        {
          label: 'What is your exercise/movement routine like? *',
          type: 'text',
          name: 'intakeMovementRoutine',
          rows: 1
        },
        {
          label: 'How is your sleep? *',
          type: 'text',
          name: 'intakeHowIsSleep',
          rows: 1
        }
      ]
    }
  },

  {
    label: 'Family Information',
    subLabel: '',
    field: 'intakeFamilyPart',
    type: 'info',
    answer: {
      type: 'list',
      items: [
        {
          label:
            'Please describe your relationship with your mother: What is the current state? How was it growing up? etc.',
          type: 'text',
          name: 'intakeRelationshipWithMother',
          rows: 1,
          optional: true
        },
        {
          label:
            'Please describe your relationship with your father: What is the current state? How was it growing up? etc.',
          type: 'text',
          name: 'intakeRelationshipWithFather',
          rows: 1,
          optional: true
        },
        {
          label: 'Do you feel you have emotional support? if so by whom? *',
          type: 'text',
          name: 'intakeHaveEmotionalSupport',
          rows: 1
        },
        {
          label:
            'Do you have any siblings? What is the state of your relationship with them?',
          type: 'text',
          name: 'intakeHaveSiblings',
          rows: 1,
          optional: true
        }
      ]
    }
  },

  {
    label: 'Relationship Information',
    subLabel: '',
    field: 'intakeRelationshipPart',
    type: 'info',
    answer: {
      type: 'list',
      items: [
        {
          label:
            "If you are in a relationship, please describe the nature of the relationship and how long you've been together.",
          type: 'text',
          name: 'intakeRelationshipNature',
          rows: 1,
          optional: true
        },
        {
          label:
            'What have the highest and lowest points in your relationship been? ',
          type: 'text',
          name: 'intakeRelationshipLoHiPoints',
          rows: 1,
          optional: true
        },
        {
          label:
            'Describe your current living situation: Do you live alone, with family, etc... *',
          type: 'text',
          name: 'intakeLivingSituation',
          rows: 1
        }
      ]
    }
  },

  {
    label: 'Pregnancy Information',
    subLabel: 'Please mark N/A if these questions if do not apply.',
    field: 'intakePregnancyPart',
    type: 'info',
    answer: {
      type: 'list',
      items: [
        {
          label: 'Do you have a history of infertility? *',
          type: 'single_select',
          level: 'child',
          field: 'historyOfInfertility',
          options: [
            { key: 'history of infertility yes', value: 'Yes' },
            { key: 'history of infertility no', value: 'No' },
            { key: 'history of infertility NA', value: 'N/A' }
          ]
        },
        {
          label:
            'Have you had any terminations, miscarriages, birth or pregnancy loss? *',
          type: 'single_select',
          level: 'child',
          field: 'pregnancyLoss',
          options: [
            { key: 'pregnancy loss yes', value: 'Yes' },
            { key: 'pregnancy loss no', value: 'No' },
            { key: 'pregnancy loss NA', value: 'N/A' }
          ]
        },
        {
          label: 'How many pregnancies have you had? *',
          type: 'text',
          name: 'intakeHowManyPregnancies',
          rows: 1
        },
        {
          label: 'How many children do you have?',
          type: 'text',
          name: 'intakeHowManyChildren',
          rows: 1,
          optional: true
        },
        {
          label: 'Are you currently expecting? If so, how far along are you?',
          type: 'text',
          name: 'intakeExpectingPregnancy',
          rows: 1,
          optional: true
        },
        {
          label: 'Did you enjoy being pregnant?',
          type: 'text',
          name: 'intakeEnjoyPregnant',
          rows: 1,
          optional: true
        },
        {
          label: 'How did/do you or how do you plan to feed the baby?',
          type: 'text',
          name: 'intakeFeedBaby',
          rows: 1,
          optional: true
        },
        {
          label:
            'Did you take any medications while pregnant? If so, which ones and what amount?',
          type: 'text',
          name: 'intakePregnantTakeMedications',
          rows: 1,
          optional: true
        },
        {
          label:
            'Did you or your infant experience medical complications during pregnancy, labour or during the postpartum period? If yes, please elaborate:',
          type: 'text',
          name: 'intakeMedicalComlications',
          rows: 1,
          optional: true
        },
        {
          label: 'Did you take any prenatal classes? If so, which ones?',
          type: 'text',
          name: 'intakeTakePrenatalClasses',
          rows: 1,
          optional: true
        },
        {
          label:
            'Are you currently attending any classes or groups? Feeding groups, mommy and me classes, etc.',
          type: 'text',
          name: 'intakeMommyClasses',
          rows: 1,
          optional: true
        },
        {
          label:
            'Please share your birth story. Was it C-section, vaginal delivery, induced, overdue, etc.',
          type: 'text',
          name: 'intakeBirthStory',
          rows: 1,
          optional: true
        },
        {
          label: 'What else would you like me to know?',
          type: 'text',
          name: 'intakeMoreInformationToKnow',
          rows: 1,
          optional: true
        }
      ]
    }
  },
  {
    label: 'Legal Involvement',
    subLabel: '',
    field: 'intakeLegalPart',
    type: 'info',
    answer: {
      type: 'list',
      items: [
        {
          label: 'Are you currently in any legal battles? *',
          type: 'single_select',
          level: 'child',
          field: 'legalBattles',
          options: [
            { key: 'legal battles yes', value: 'Yes' },
            { key: 'legal battles no', value: 'No' }
          ]
        },
        {
          label:
            'Do you have any outstanding charges? (Note: services cannot be used to mitigate charges related to inmate partner violence) *',
          type: 'single_select',
          level: 'child',
          field: 'outstandingCharges',
          options: [
            { key: 'outstanding charges yes', value: 'Yes' },
            { key: 'outstanding charges no', value: 'No' }
          ]
        },
        {
          label: 'Is/has the child protective services been involved? *',
          type: 'single_select',
          level: 'child',
          field: 'childProtectiveServicesInvolved',
          options: [
            { key: 'child protective involved yes', value: 'Yes' },
            { key: 'child protective involved no', value: 'No' }
          ]
        }
      ]
    }
  },
  {
    label: 'Consent to Momwell Services',
    subLabel:
      'The therapeutic relationship between you and your Momwell therapist is a very special one, combining both a personal and contractual element. To ensure that the work we do together is successful, it is important to discuss and agree on the expectations of both parties. This consent form will provide a clear structure for the work that we do. Please do not hesitate to ask any questions or discuss any of the information in this document with your therapist. Once you have read and understood this information, please indicate your agreement by checking the following terms:',
    field: 'intakeConsentMomwellServices',
    type: 'info',
    answer: {
      type: 'consent-check',
      label:
        'I certify that the medical history provided is correct to my knowledge.',
      name: 'intakeConsentMomwellServicesAnswer',
      required: true
    }
  },
  {
    label: 'The Therapeutic Process',
    subLabel: `It is wonderful that you have chosen to take this step and seek out therapy at Momwell.
       We are here to support you through this process and want to make sure you are aware of the potential risks and benefits that may come with it.
        It is important to note that there is no guarantee of improvement in every situation and that this process may bring up difficult emotions.
         We will respect your right to choose not to discuss a topic or to stop the session or service at any time.
          We strive to work collaboratively with you and make sure your questions and concerns are addressed.
           Mental health services can bring many benefits, such as reduced feelings of distress,
            improved coping skills, better relationships, and resolution of specific problems.
             We want to ensure that our services are used for therapeutic purposes only, and not for any legal or forensic purposes.
              We are here for you and want to make sure you feel comfortable and supported throughout this process.
      `,
    field: 'intakeTherapeuticProcess',
    type: 'info',
    answer: {
      type: 'consent-check',
      label: 'I understand the risks and benefits of therapy',
      name: 'intakeTherapeuticProcessAnswer',
      required: true
    }
  },
  {
    label: 'Limitations of Confidentiality',
    subLabel: `While therapy is a confidential service, there are limits to confidentiality which are guided by regulatory bodies,
       such as disclosures of child abuse/suspected child abuse, disclosure that one may seriously harm themselves or another,
        and disclosures of abuse by a health professional. Additionally, information may be shared for supervision,
         consultation, training of internal students, audit purposes, or if subpoenaed by court.
          We understand that the thought of being reported can be frightening, and we want to assure you that our mom therapists
           are highly trained professionals who are well-versed in distinguishing between intrusive thoughts and intent to harm.
             In the rare instance that they do need to break confidentiality, they would have a conversation with you first.
              For more information or if you have concerns, please speak to your therapist.

      `,
    field: 'intakeLimitationsOfConfidentiality',
    type: 'info',
    answer: {
      type: 'consent-check',
      label: 'I understand the limits of confidentiality.',
      name: 'intakeLimitationsOfConfidentialityAnswer',
      required: true
    }
  },
  {
    label: 'Clinical Notes',
    subLabel: `Clinical notes are taken solely for therapeutic purposes and shall not be used in any legal proceedings.
       Our policy is to not provide services for the purpose of resolving criminal charges or child custody/access cases.
        If you have any such matters pending, please contact us before your session so that we can discuss 
        the appropriate services. Clinical notes are securely stored on our PIPEDA/HIPPA-compliant platform and 
        are only available to your respective provider. Files are maintained for a period of 10 years after active treatment,
         or 10 years after the youngest participating member reaches the age of 18.

      `,
    field: 'intakeClinicalNotes',
    type: 'info',
    answer: {
      type: 'consent-check',
      label:
        'I understand that clinical notes are kept and are not for legal use.',
      name: 'intakeClinicalNotesAnswer',
      required: true
    }
  },
  {
    label: 'Privacy and Sharing of Information',
    subLabel: `I authorize the clinic and its associated health professionals to collect my personal and medical
       information as documented above. I understand that only my direct therapist will have access to my charts and records,
        but that Momwell will have access to my contact, billing and scheduling information. 
        I also understand that my personal and medical information is confidential and will only be disclosed 
        to third parties with my permission. For more information review our privacy policy and terms and conditions.
      `,
    field: 'intakeSharingInformation',
    type: 'info',
    answer: {
      type: 'consent-check',
      label: 'I understand and agree to the privacy policy.',
      name: 'intakeSharingInformationAnswer',
      required: true
    }
  },
  {
    label: 'Fees',
    subLabel: `Virtual therapy fees range from $150- $220 per 50-minute session depending on the Therapist.
       Fees are charged post-session by credit card, through our platform which is enabled by Stripe.
        Payment information is required by the system prior to joining the session. 
      Virtual therapy services are paid in full at the end of each session by the credit card on file.
       Each person’s insurance or benefits coverage is different and therefore we can’t make any guarantees 
       that virtual therapy services are covered.      
      `,
    field: 'intakeFees',
    type: 'info',
    answer: {
      type: 'consent-check',
      label: 'I understand the fees and that reimbursement is not guaranteed.',
      name: 'intakeFeesAnswer',
      required: true
    }
  },
  {
    label: 'Good Faith Estimate for Therapy',
    subLabel: `The cost of therapy will be determined by the hourly rate of your therapist and the number of sessions booked. 
      Generally, 6-10  sessions are recommended, however, you and your therapist may choose to extend therapy or discontinue at any time.
    We understand that budget can be a barrier for many clients in seeking the care they need. 
      That's why we offer flexible treatment planning that can be tailored to suit your budget, so you can receive the care you need without financial barriers. 
      Let us work together to create a plan and set realistic achievable goals that fit your needs without compromising your financial needs. For more information please visit our Pricing page. 
      `,
    field: 'intakeGoodFaithEstimateForTherapy',
    type: 'info',
    answer: {
      type: 'consent-check',
      label: 'I understand the fees associated with my therapy.',
      name: 'intakeGoodFaithEstimateForTherapyAnswer',
      required: true
    }
  },
  {
    label: 'Cancellation Policy',
    subLabel: `Your appointment time is reserved just for you. A late cancellation or missed visit leaves
       a vacancy in your therapist’s day that could have been filled by another client.
        As such, we require 24 hours notice for any cancellations or changes to your appointment.
         Clients who provide less than 24 hours notice, or miss their appointment, will be charged a 50% cancellation fee. 

      `,
    field: 'intakeCancellationPolicy',
    type: 'info',
    answer: {
      type: 'consent-check',
      label: 'I am aware of and understand the Cancellation Policy.',
      name: 'intakeCancellationPolicyAnswer',
      required: true
    }
  },
  {
    label: 'Not a Crisis Service',
    subLabel: `By utilizing this service, you acknowledge that you are not in crisis and that this service
       should not be used as a means of communication in a crisis situation. If you are in crisis,
        please contact 911 or attend your nearest hospital. You may also reach out to the 24 hr crisis
         line with Canadian Suicide Prevention Service, at 1-833-456-4566 or a local crisis line, 
         or the 24/7 National Suicide Prevention Lifeline in the United States at 988.
      `,
    field: 'intakeNotACrisisService',
    type: 'info',
    answer: {
      type: 'consent-check',
      label: 'I confirm that I am not in crisis.',
      name: 'intakeNotACrisisServiceAnswer',
      required: true
    }
  },
  {
    label: 'Termination',
    subLabel: `At Momwell, we understand that ending our therapeutic relationship can be difficult.
       Therefore, we want to ensure that we have a respectful termination process.
        Your therapist will work with you to determine how long the termination process should last,
         depending on how long and intense our treatment has been. If your therapist believes that 
         the treatment is no longer effective, or if you are in default on payment,
          they will discuss the matter with you and explore options. Before moving forward with service termination,
           they will  provide you with a list of qualified therapists for your continued care,
            or direct you to another referral source. Lastly, if you fail to schedule an appointment 
            for three consecutive weeks, unless other arrangements have been made in advance,
             your therapist will have to consider the professional relationship discontinued.

      `,
    field: 'intakeTermination',
    type: 'info',
    answer: {
      type: 'consent-check',
      label: 'I understand the rules regarding termination of service.',
      name: 'intakeTerminationAnswer',
      required: true
    }
  },
  {
    label: 'Use of Email',
    subLabel: `Email communication is not a secure method of transmitting information and Momwell's therapists
       may use email for billing and scheduling purposes only, not for personal health information.
        You agree not to send confidential information through email and understand that Momwell cannot guarantee
         the confidentiality or security of information transmitted through this method.
          You accept the potential risks associated with email communication and assume responsibility for maintaining
           the confidentiality of any personal health information communicated through email.

      `,
    field: 'intakeUseOfEmail',
    type: 'info',
    answer: {
      type: 'consent-check',
      label: 'I understand the risks associated with email communication',
      name: 'intakeUseOfEmailAnswer',
      required: true
    }
  },
  {
    label: 'Technology Risks',
    subLabel: `By signing the consent to services, you agree to use the video-conferencing platform provided by Momwell
       for virtual sessions, and understand the potential benefits and risks of video-conferencing. 
      You agree that confidentiality still applies to teleservices, you will use a secure internet connection,
       be in a quiet, private space and not record the session without permission.
        You also understand and accept the risks associated with Internet-based communication including
         but not limited to privacy and security of communication not being guaranteed.
          You understand the potential risks, consequences, and benefits associated with telemedicine and
           the provider's inability to make visual and olfactory observations.
             Lastly you are aware that that you have the option of withdrawing consent at anytime and thus terminating
              the relationship. For more information visit our Privacy Policy.

      `,
    field: 'intakeTechnologyRisks',
    type: 'info',
    answer: {
      type: 'consent-check',
      label: 'I understand the technology risks.',
      name: 'intakeTechnologyRisksAnswer',
      required: true
    }
  },
  {
    label:
      'If YOU HAVE ANY QUESTIONS ABOUT OUR POLICIES PLEASE SPEAK TO YOUR THERAPIST. If doing couples counseling, both partners will need to sign separate consent forms.',
    field: 'intakeHaveQuestions',
    type: 'info',
    answer: {
      type: 'consent-check',
      label: 'I have read the treatment service policies.',
      name: 'intakeHaveQuestionsAnswer',
      required: true
    }
  }
];
export default questionsModels;
